import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@/app/shared/shared.module';
import { AccountRoutingModule } from './account-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { AccountComponent } from './account.component';
import { ProfileComponent } from './profile/profile.component';
import { OrdersComponent } from './orders/orders.component';
import { OrderCardComponent } from './orders/order-card/order-card.component';
import { OrderDetailsComponent } from './orders/details/details.component';
import { WishListComponent } from './wish-list/wish-list.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AdressesComponent } from './adresses/adresses.component';
import { BusinessProfileComponent } from './business-profile/business-profile.component';
import { InviteComponent } from './invite/invite.component';
import { ReportComponent } from './report/report.component';
import { CompanionComponent } from './companion/companion.component';
import { RegisterProgramComponent } from './companion/register/register-program.component';
import { BusinessRegistrationCertificateComponent } from './business-profile/business-registration-certificate/business-registration-certificate.component';
import { PharmaceuticalStandardComponent } from './business-profile/pharmaceutical-standard/pharmaceutical-standard.component';
import { BusinessRegistrationCertificate2Component } from './business-profile/business-registration-certificate-2/business-registration-certificate-2.component';
import { NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';
import { WalletComponent } from './wallet/wallet.component';
import { PointWalletComponent } from "@/app/components/account/wallet/point-wallet/point-wallet.component";
import { ReturnOrderComponent } from './return-order/return-order.component';
import { ReturnOrderModalComponent } from './return-order/modal/return-order-modal.component';
import { ReturnOrderListComponent } from './return-order/list/return-order-list.component';
import { ReturnOrderListModalComponent } from './return-order/list/modal/return-order-list-modal.component';
import { ReturnOrderDetailComponent } from './return-order/detail/return-order-detail.component';
import { ShipmentListModalComponent } from "./shipments/list/modal/shipment-list-modal.component";
import { ShipmentListComponent } from "./shipments/list/shipment-list.component";
import { ShipmentDetailComponent } from "./shipments/detail/shipment-detail.component";
import { UserGiftComponent } from './user-gift/user-gift.component';
import { OrderShippingModalComponent } from './orders/order-shipping/modal/order-shipping-modal/order-shipping-modal.component';
import { PurchasedProductComponent } from './purchased-products/purchased-product.component';
import { OrderTemplateComponent } from './order-template/order-template.component';


@NgModule({
  declarations: [
    AccountComponent,
    ProfileComponent,
    OrdersComponent,
    OrderCardComponent,
    OrderDetailsComponent,
    ChangePasswordComponent,
    WishListComponent,
    AdressesComponent,
    BusinessProfileComponent,
    InviteComponent,
    ReportComponent,
    CompanionComponent,
    RegisterProgramComponent,
    BusinessRegistrationCertificateComponent,
    BusinessRegistrationCertificate2Component,
    PharmaceuticalStandardComponent,
    WalletComponent,
    PointWalletComponent,
    ReturnOrderModalComponent,
    ReturnOrderComponent,
    ReturnOrderListComponent,
    ReturnOrderListModalComponent,
    ReturnOrderDetailComponent,
    ShipmentListModalComponent,
    ShipmentListComponent,
    ShipmentDetailComponent,
    UserGiftComponent,
    OrderShippingModalComponent,
    PurchasedProductComponent,
    OrderTemplateComponent,
  ],
  imports: [
    CommonModule,
    AccountRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    NgxScannerQrcodeModule,
    RouterModule
  ],
  exports: [
    SharedModule
  ]
})
export class AccountModule { }
